import { Card, Elevation, Icon } from "@blueprintjs/core";
import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import assets from "../../assets";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { EDrupalRoutes } from "../EDrupalRoutes";

export interface IDrupalBreedInfoBoxProps {
  breedName: string;
  breedId: number;
  imageLink: string;
}

const MainContainer = styled(Card)`
  width: 25rem;
  height: 25rem;
  background-color: #0091ff;
  padding: 0px;
  margin: 1.5rem;
`;

const Container = styled.div`
  height: 10rem;
  width: 24.5rem;
  margin-left: 0.5rem;
  background-color: #ffffff;
  border-radius: 3px;
`;

const PictureContainer = styled.img`
  width: 25rem;
  height: 15rem;
  background-color: white;
  border-radius: 3px;
`;

const GoToDetail = styled(Link)`
  color: #0091ff;
  :hover & {
    color: #0b61a3;
  }
`;

export const DrupalBreedInfoBox: React.FunctionComponent<IDrupalBreedInfoBoxProps> = ({
  breedName,
  breedId,
  imageLink,
}) => {
  const { t } = useTl();

  return (
    <MainContainer interactive={true} elevation={Elevation.FOUR}>
      <PictureContainer alt={breedName} src={assets.images.dogDefault}/>
      <Container>
        <h2 style={{ fontSize: "25px", marginLeft: "3rem", marginBottom: "1rem" }}>{breedName}</h2>
        <div style={{ marginLeft: "4rem" }}>
          <GoToDetail to={`${EDrupalRoutes.breed}/${breedId}`}>
            {t(ETLCodes.GoToDetail)}
            <Icon style={{ marginLeft: "0.3rem" }} icon="arrow-right"/>
          </GoToDetail>
        </div>
      </Container>
    </MainContainer>
  );
};
